// 图层透明度控制
import { getLayerExist } from './layerStatusControl'

function setLayerShow (params, isShow, self) {
  // todo 参数校验
  const layerInfoAll = getLayerExist(params)
  // let addInfo = {
  //   info: params,
  //   layer: imageProvider,
  //   market: imageMarket
  // }
  if (!layerInfoAll) {
    return false
  }
  const layerMarket = layerInfoAll.market
  if (layerMarket) {
    layerMarket.show = isShow
    return true
  }
  return false
}

export { setLayerShow }
